import Vue from 'vue'
window.Vue = Vue

require('./bootstrap');
require('./components');
require('./extensions');

import Cookies from './helpers/cookies.js';
window.cookies = new Cookies()

import clickOutside from './directives/click-outside';

window.TranslationManager = require('./i18n').default;

import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: localStorage.getItem('locale') || document.documentElement.lang || 'en',
    fallbackLocale: 'en',
    messages: {
        en: {}
    }
});


window.i18n = i18n;
Vue.directive('click-outside', clickOutside);

import Api from './api.js'
window.api = new Api()

import Alert from './helpers/alert.js';
window.alert = new Alert();

import Utils from './helpers/utils.js'
window.utils = new Utils()


import Validator from './helpers/validator.js'
window.validator = new Validator()

import Storage from './helpers/storage.js'
window.storage = new Storage()

import Amplitude from './helpers/amplitude.js'
window.amplitude = new Amplitude()

import Errors from './helpers/errors.js'
window.Errors = Errors;

import VueLazyload from 'vue-lazyload'
const errorimage = require('./assets/placeholder.png')

Vue.prototype.$locations = require('./assets/locations.json')
Vue.prototype.$genders = require('./assets/genders.json')
Vue.prototype.$occupations = require('./assets/occupations.json')
Vue.prototype.$educations = require('./assets/educations.json')
Vue.prototype.$genres = require('./assets/genres.json')
Vue.prototype.$formats = require('./assets/formats.json')
Vue.prototype.$activities = require('./assets/activities.json')
Vue.prototype.$interests = require('./assets/interests.json')
Vue.prototype.$languages = require('./assets/languages.json')


Vue.prototype.$eventBus = new Vue()

Vue.prototype.$launchDate = Date.parse('20 Feb 2022 13:01:00 GMT')

Vue.prototype.$definedAdSlots = {}

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: errorimage,
    attempt: 1
})

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

Vue.use(Toast, {
    position: "top-right",
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false
});

const app = new Vue({
    el: '#app',
    i18n: window.i18n
});

// Add translation config to window
// window.config = {
//     translation: {
//         supported_languages: JSON.parse(document.querySelector('meta[name="supported-languages"]').content),
//         default_languages: JSON.parse(document.querySelector('meta[name="default-languages"]').content)
//     }
// };

// Initialize language names
window.api.call('get', 'translations/languages')
    .then(response => {
        window.languageNames = response.languageNames;
    })
    .catch(error => {
        console.error('Failed to load language names:', error);
    });
